import React, { useState, useEffect } from 'react';
import './Productos.css';

import { useTheme } from '@mui/material/styles';
import { DataGrid } from '@mui/x-data-grid';

import CargaSpinner from '../../components/AccionesPartes/CargaSpinner';
import {
  Snackbar, Alert, TextField, Button, MenuItem, IconButton, useMediaQuery, Dialog, DialogTitle, DialogContent, DialogActions, ButtonGroup,
  tooltipClasses, Typography, styled, Zoom, Tooltip, FormControl, FormLabel, RadioGroup, FormControlLabel, Radio, List, ListItem, ListItemText,
  Divider, Accordion, AccordionSummary, AccordionDetails, Grid, Checkbox
} from '@mui/material';

import SearchIcon from '@mui/icons-material/Search';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import RotateLeftIcon from "@mui/icons-material/RotateLeft";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';

import MostrarError from '../../components/AccionesPartes/MostrarError';

const HtmlTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} disableInteractive />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#f5f5f9',
    color: 'rgba(0, 0, 0, 0.87)',
    maxWidth: 220,
    fontSize: theme.typography.pxToRem(12),
    border: '1px solid #dadde9',
  },
}));

function Productos() {

  const API_URL = 'https://api.workers.grupotel.com/';

  const fd = new FormData();
  const requestOptions = {
    method: 'POST',
    body: fd
  };

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

  //Conjunto para mostrar un Alert con el resultado de la petición
  const [mensajeError, setMensajeError] = useState('');
  const [tipoError, setTipoError] = useState('');
  const [contadorError, setContadorError] = useState(1);
  const [estadoAlert, setEstadoAlert] = React.useState(false);

  //Funcion basica para mostrar alert de errores o success.
  const mostrarError = (mensajeError, tipoError) => {
    setMensajeError(mensajeError);
    if (tipoError) {
      setTipoError(tipoError);
    } else {
      setTipoError("error");
    }
    setContadorError(contadorError + 1);
    setEstadoAlert(true);
    const timer2 = setTimeout(() => {
      setEstadoAlert(false);
    }, 3000);
    return () => clearTimeout(timer2);
  };

  const [contadorSpinner, setContadorSpinner] = React.useState(false);

  const [producto, setProducto] = useState({
    nombre: '',
    proveedor: '',
    marca: '',
    eco: false
  });
  const [listaProducto, setListaProducto] = useState([]);
  const [listaTodosProductos, setListaTodosProducto] = useState([]);

  const [listaPDFNuevoParte, setListaPDFNuevoParte] = useState([]);
  const columnas = [
    {
      headerClassName: 'header-grid', field: 'id', headerName: 'ID', width: 80,
    },
    {
      headerClassName: 'header-grid', field: 'nombre', headerName: 'Nombre', width: 300,
    },
    {
      headerClassName: 'header-grid', field: 'proveedor', headerName: 'Proveedoor', width: 180,
    },
    {
      headerClassName: 'header-grid', field: 'marca', headerName: 'Marca', width: 180,
    },
    {
      headerClassName: 'header-grid', field: 'eco', headerName: 'Eco', width: 40,
      renderCell: (params) => {
        let eco = params.row.eco;

        return eco === 1 ? (
          <IconButton className="icon-button" rel="noopener noreferrer">
            <CheckCircleIcon color="success" />
          </IconButton>
        ) : ' ';
      }
    },
    {
      headerClassName: 'header-grid', field: 'pdf', headerName: 'PDF', width: 40, sortable: false, align: 'center',
      renderCell: (params) => {
        const id = params.row.id;
        const url = `https://api.workers.grupotel.com/documentos/productos_quimicos/${String(id).padStart(6, '0')}.pdf`;

        return (
          <IconButton
          className='icon-button'
          component="a"
            href={url}
            target="_blank"
            rel="noopener noreferrer"
          >
            <PictureAsPdfIcon />
          </IconButton>
        );
      }
    }
  ]

  const [actualizo, setActualizo] = useState(true);
  const actualizarProductos = () => {
    setActualizo(!actualizo);
  };

  // Dialog crear
  const [estadoCrear, setEstadoCrear] = React.useState(false);
  const mostrarCrear = () => {
    setProducto({
      nombre: '',
      proveedor: '',
      marca: ''
    });
    setEstadoCrear(true);
  };
  const comprobarESCCrear = (event) => {
    if (event.keyCode === 27) {
      cancelCrear();
    }
  };
  const cancelCrear = () => {
    setProducto({
      nombre: '',
      proveedor: '',
      marca: ''
    });
    setListaPDFNuevoParte([]);
    setEstadoCrear(false);
    actualizarProductos();
  };

  // Quitar el pdf seleccionado
  const borrarPDFNuevoParte = (id) => {
    setListaPDFNuevoParte(listaPDFNuevoParte.filter((pdf) => pdf.id !== id));
  };

  // Abrir imagen o pdf  en ventanda nueva
  const ventanaImagen = (ruta) => {
    const rutaMostrar = ruta.includes("min_") ? ruta.replace("min_", "") : ruta;
    window.open(rutaMostrar);
  };

  const selecImage = (event) => {
    const files = event.target.files;

    // Verificar si se seleccionó algún archivo
    if (files.length === 0) {
      // Vaciar las listas de imágenes y PDFs, si no se seleccionó ningún archivo

      setListaPDFNuevoParte([]);
      event.target.value = null;  // Limpiar el input
      return;
    }
    //console.log(files)

    let nuevosPDFs = [];

    // Filtrar los archivos de imagen y PDF
    const pdfs = Array.from(files).filter(file => file.type === 'application/pdf');

    //Variable para saber el peso de los archivos.
    let pesoArchivos = 0;

    // Montar el array de PDFs
    pdfs.forEach((file, index) => {
      let nombrePdf = "";
      if (file.name.length > 29) {
        nombrePdf = file.name.substring(0, 29) + "...";
      } else {
        nombrePdf = file.name;
      }
      pesoArchivos += file.size;
      nuevosPDFs.push({
        id: index,
        ruta: URL.createObjectURL(file),
        nombre: nombrePdf,
        archivo: file
      });
    });

    //Comprobación de si se supera el maximo de 32
    if (pesoArchivos >= 32000000) {
      // console.log(pesoArchivos);
      mostrarError("Los archivos superan los 32 MB");
      console.log("Los archivos superan los 32 MB");
      setListaPDFNuevoParte([]);

      event.target.value = null;  // Limpiar el input
      return;
    }

    setListaPDFNuevoParte(nuevosPDFs);
  };

  // Comprobamos si ya hay productos con ese nombre
  const comprobarEnterProd = (e) => {
    if (e.key === 'Enter') {
      getProducto();
    }
  };
  const comprobarProducto = () => {
    getProducto();
  };

  const getProducto = () => {

    if (producto.nombre.trim() === "") {
      mostrarError("Indique el Nombre del Producto a buscar");
    } else {
      // console.log(producto.nombre);

      fd.append("f", "producto.getProductosNombre");
      fd.append("token", localStorage.getItem('token'));
      fd.append("nombre", producto.nombre.trim());

      fetch(API_URL, requestOptions)
        .then(response => response.json())
        .then(result => {
          let error = result.error;

          // console.log(result);
          if (error.id === 0) {
            mostrarError("Productos obtenidos", "success");
            setListaProducto(result.data);
          } else {
            mostrarError(error.msg);
          }
        })
        .catch(() => {
          mostrarError("No se ha podido obtener el producto");
        })
    }
  };

  const crearProducto = () => {
    // console.log(listaPDFNuevoParte);

    if (producto.nombre.trim() === "") {
      mostrarError("Indique el Nombre del Producto a buscar");
      return;
    }

    if (listaPDFNuevoParte.length === 0) {
      mostrarError("Debe adjuntar un PDF");
      return;
    }

    fd.append("f", "producto.setNewProducto");
    fd.append("token", localStorage.getItem('token'));
    fd.append("nombre", producto.nombre.trim());
    fd.append("proveedor", producto.proveedor.trim());
    fd.append("marca", producto.marca.trim());
    fd.append("eco", producto.eco ? 1 : 0);

    // Solo un archivo
    fd.append("file", listaPDFNuevoParte[0].archivo);

    fetch(API_URL, requestOptions)
      .then(response => response.json())
      .then(result => {
        let error = result.error;

        // console.log(result);
        if (error.id === 0) {
          mostrarError("Producto creado correctamente", "success");
          cancelCrear();
        } else {
          mostrarError(error.msg);
          console.log(error.msg);
        }
      })
      .catch(() => {
        mostrarError("No se ha podido obtener el producto");
      })

  };

  // Dialog Filtrar
  const [estadoFiltro, setEstadoFiltrar] = React.useState(false);
  const [activoFiltro, setActivoFiltro] = React.useState(false);

  const estadoInicial = {
    id: '',
    nombre: '',
    proveedor: '',
    marca: '',
    activo: '',
    eco: 0
  };
  const [filtros, setFiltros] = useState(estadoInicial);
  const [tempFiltros, setTempFiltros] = useState(estadoInicial);

  const mostrarFiltros = () => {
    // Creamos una copia temporal de filtros
    setTempFiltros(filtros);
    setEstadoFiltrar(true);
  };
  const comprobarESCFiltrar = (event) => {
    if (event.keyCode === 27) {
      cancelFiltrar();
    }
  };
  const cancelFiltrar = () => {
    setTempFiltros(filtros);
    setEstadoFiltrar(false);
  };
  const borrarFiltros = () => {
    setFiltros(estadoInicial);
    setTempFiltros(estadoInicial);
  };

  const filtrarProductos = () => {
    setFiltros(tempFiltros);
    setEstadoFiltrar(false);

    // Comprobar filtros
    actualizarProductos();
  };

  // const actualizarFiltros = (e) => {
  //   const { name, value } = e.target;
  //   setTempFiltros((prev) => ({ ...prev, [name]: value }));
  // };

  const actualizarFiltros = (e) => {
    const { name, value, type, checked } = e.target;

    if (type === "checkbox") {
      if (checked) {
        setTempFiltros((prev) => ({
          ...prev,
          [name]: 1
        }));
      } else {
        setTempFiltros((prev) => ({
          ...prev,
          [name]: 0
        }));
      }
    } else {
      setTempFiltros((prev) => ({
        ...prev,
        [name]: value
      }));
    }
  };

  const comprobarEnter = (e) => {
    if (e.key === 'Enter') {
      actualizarProductos();
    }
  };

  /**********************/
  // Editar producto
  const [productoSeleccionado, setProductoSeleccionado] = useState(null);
  // Copia
  const [productoEdit, setProductoEdit] = useState(null);
  const [hayCambios, setHayCambios] = useState(false);

  // Hotel seleccionado
  const [hotelTrabajo, setHotelTrabajo] = useState(0);

  // Estado departamentos
  const [departamentos, setDepartamentos] = useState([]); // Departamentos que el producto
  const [idsDepartamentosPoner, setIdsDepartamentosPoner] = useState([]);
  const [idsDepartamentosQuitar, setIdsDepartamentosQuitar] = useState([]);

  const [hotelesLista, setHotelesLista] = useState([]); // Todos los hoteles
  const [departamentosLista, setDepartamentosLista] = useState([]); // Todos los departamentos

  const clickInfoProducto = (params) => {

    getHoteles();
    getDepartamentos();

    setHotelTrabajo(0);
    setDepartamentos([]);
    setIdsDepartamentosPoner([]);
    setIdsDepartamentosQuitar([]);

    const prod = { ...params.row };

    if (!prod.archivo) {
      prod.rutaPDF = `https://api.workers.grupotel.com/documentos/productos_quimicos/${String(prod.id).padStart(6, "0")}.pdf`;
    }
    prod.nuevoPDF = "";
    // console.log("Clic ")
    // console.log(prod);

    setProductoSeleccionado(prod);
    setProductoEdit({ ...prod });

    setHayCambios(false);
  };

  // Detectar cambios en inputs
  // const handleEditChange = (e) => {
  //   const { name, value } = e.target;
  //   setProductoEdit((prev) => ({ ...prev, [name]: value }));
  // };
  const handleEditChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (type === "checkbox") {
      if (checked) {
        setProductoEdit((prev) => ({
          ...prev,
          [name]: 1
        }));
      } else {
        setProductoEdit((prev) => ({
          ...prev,
          [name]: 0
        }));
      }
    } else {
      setProductoEdit((prev) => ({
        ...prev,
        [name]: value
      }));
    }
  };

  const cancelarEdicion = () => {
    setProductoEdit({ ...productoSeleccionado });
    setIdsDepartamentosPoner([]);
    setIdsDepartamentosQuitar([]);
    setHayCambios(false);
  };

  const guardarEdicion = () => {

    if (!productoEdit.nombre || productoEdit.nombre.trim() === "") {
      mostrarError("El campo Nombre es obligatorio");
      return;
    }

    // Detectar diferencias en inputs básicos
    const cambios = {};
    Object.keys(productoEdit).forEach((key) => {
      if (productoEdit[key] !== productoSeleccionado[key]) {
        cambios[key] = productoEdit[key];
      }
    });

    // Añadir permisos (solo si hay cambios)
    if (idsDepartamentosPoner.length > 0) {
      cambios.departamentosPoner = idsDepartamentosPoner;
      cambios.id_hotel = hotelTrabajo;
    }
    // Quitar permisos ()
    if (idsDepartamentosQuitar.length > 0) {
      cambios.departamentosQuitar = idsDepartamentosQuitar;
      cambios.id_hotel = hotelTrabajo;
    }

    // Comprobar si no hay nada que guardar
    if (!productoEdit.nuevoPDF && Object.keys(cambios).length === 0) {
      mostrarError("No hay cambios para guardar");
      return;
    }

    const fd = new FormData();
    fd.append("f", "producto.updateProducto");
    fd.append("token", localStorage.getItem('token'));
    fd.append("id_producto", productoEdit.id);
    fd.append("cambios", JSON.stringify(cambios));

    if (productoEdit.nuevoPDF) {
      fd.append("nuevoPDF", productoEdit.nuevoPDF);
    }

    const requestOptions = {
      method: 'POST',
      body: fd
    };
    fetch(API_URL, requestOptions)
      .then(response => response.json())
      .then(result => {
        console.log(result)
        let error = result.error;
        if (error.id === 0) {
          mostrarError("Producto actualizado", "success");
          setHayCambios(false);
          getDepartamentosHotel(hotelTrabajo);
          getProductos();
        } else {
          mostrarError(error.msg);
          console.log(error);
        }
      })
      .catch(() => {
        mostrarError("No se ha actualizar los datos del Producto");
      })
  };

  const getDepartamentos = () => {
    const fd = new FormData();
    fd.append("f", "usuarios.getDepartamentos");
    fd.append("token", localStorage.getItem('token'));

    const requestOptions = {
      method: 'POST',
      body: fd
    };
    fetch(API_URL, requestOptions)
      .then(response => response.json())
      .then(result => {
        let error = result.error;
        if (error.id === 0) {
          // console.log("Informacion de Departamentos");
          // console.log(result);
          const departamentos = Object.entries(result.departamentos).map(([id, nombre]) => ({
            id: Number(id),
            nombre: nombre
          }));
          // Filtramos [Desarrollo, Sistema informaticos, Maestro]
          const excluir = [71, 3, 1000];
          const filtrados = departamentos.filter((dep) => !excluir.includes(dep.id));

          filtrados.sort((a, b) =>
            a.nombre.localeCompare(b.nombre, "es", { sensitivity: "base" })
          );

          // departamentos.unshift({ "id": " ", "nombre": " " });
          setDepartamentosLista(filtrados);
          // console.log(departamentos);
        } else {
          mostrarError(error.msg);
          console.log(error);
        }
      })
      .catch(() => {
        mostrarError("No se ha podido obtener la informacion de los Departamentos ");
      })
  };
  const getHoteles = () => {
    let hoteles = localStorage.getItem('hoteles');
    let listaHoteles = JSON.parse(hoteles);
    // listaHoteles.push({ value: '', label: '' });
    setHotelesLista(listaHoteles);
  };


  const toggleDepartamento = (idDep) => {
    if (idsDepartamentosQuitar.includes(idDep)) {
      // Si ya está marcado para quitar → lo desmarcamos
      setIdsDepartamentosQuitar(idsDepartamentosQuitar.filter((d) => d !== idDep));
    } else if (idsDepartamentosPoner.includes(idDep)) {
      // Si ya está marcado para poner → lo desmarcamos
      setIdsDepartamentosPoner(idsDepartamentosPoner.filter((d) => d !== idDep));
    } else {
      // Verificamos si este dep estaba asignado originalmente
      const estabaAsignado = departamentos.includes(idDep);

      if (estabaAsignado) {
        // Estaba asignado → lo mandamos a quitar
        setIdsDepartamentosQuitar([...idsDepartamentosQuitar, idDep]);
      } else {
        // No estaba asignado → lo mandamos a poner
        setIdsDepartamentosPoner([...idsDepartamentosPoner, idDep]);
      }
    }
  };

  const cambiaHotelTrabajo = async (event) => {

    if (event.target.name === 'id_hotel') {
      const idHotel = event.target.value;
      setHotelTrabajo(idHotel);

      // console.log("Se cambia el id Hotel : " + idHotel)

      if (idHotel && idHotel != 0) {
        getDepartamentosHotel(idHotel);

      } else {
        // Si no hay hotel seleccionado, limpiamos departamentos
        setDepartamentos([]);
        setIdsDepartamentosPoner([]);
        setIdsDepartamentosQuitar([]);
      }
    }
  };

  const getDepartamentosHotel = async (idHotel) => {

    fd.append("f", "producto.getDepartamentosProducto");
    fd.append("token", localStorage.getItem('token'));
    fd.append("id_producto", productoEdit.id);
    fd.append("id_hotel", idHotel);

    fetch(API_URL, requestOptions)
      .then(response => response.json())
      .then(result => {
        let error = result.error;

        // console.log(result);
        if (error.id === 0) {
          // Guardamos los departamentos que ya están asignados a ese producto en ese hotel
          setDepartamentos(result.asignados || []);

        } else {
          setDepartamentos([]);
          mostrarError(error.msg);
          console.log(error.msg);
        }
        setIdsDepartamentosPoner([]);
        setIdsDepartamentosQuitar([]);
      })
      .catch(() => {
        mostrarError("No se ha podido obtener la informacion de los Departamentos ");
      })
  }

  /**********************/
  const getProductos = () => {
    const fd = new FormData();
    fd.append("f", "producto.getProductos");
    fd.append("token", localStorage.getItem('token'));

    let hayFiltros = false;
    if (filtros.id != '') { fd.append("id", filtros.id.trim()); hayFiltros = true; }
    if (filtros.nombre != '') { fd.append("nombre", filtros.nombre.trim()); hayFiltros = true; }
    if (filtros.proveedor != '') { fd.append("proveedor", filtros.proveedor.trim()); hayFiltros = true; }
    if (filtros.marca != '') { fd.append("marca", filtros.marca.trim()); hayFiltros = true; }
    if (filtros.activo != '') { fd.append("activo", filtros.activo.trim()); hayFiltros = true; }
    if (filtros.eco != '' && filtros.eco != 0) { fd.append("eco", filtros.eco); hayFiltros = true; }
    setActivoFiltro(hayFiltros);

    const requestOptions = {
      method: 'POST',
      body: fd
    };

    fetch(API_URL, requestOptions)
      .then(response => response.json())
      .then(result => {
        let error = result.error;

        // console.log(result);
        if (error.id === 0) {
          mostrarError("Productos obtenidos", "success");
          setListaTodosProducto(result.data);
        } else {
          mostrarError(error.msg);
          console.log(error.msg);
        }
      })
      .catch(() => {
        mostrarError("No se ha podido obtener el producto");
      })

  };

  useEffect(() => {
    // Función getProductos
    getProductos();
    let tiempoActualizar = 60000 * 5;//Tiempo para actualizar desde la ultima carga 5 min
    const timer = setTimeout(() => { //Iniciamos el timer
      setActualizo(!actualizo);
      getProductos();
    }, tiempoActualizar);
    return () => clearTimeout(timer);//Detenemos el timer para que si realizamos algun cambio no quede un timer que recargue los componentes.

  }, [actualizo])


  useEffect(() => {
    if (!productoEdit || !productoSeleccionado) {
      setHayCambios(false);
      return;
    }

    // Diferencias en campos básicos (ignoramos nuevoPDF porque no está en productoSeleccionado)
    const cambiosCampos = Object.keys(productoEdit)
      .filter((key) => key !== "nuevoPDF")
      .some((key) => productoEdit[key] !== productoSeleccionado[key]);

    let cambiosDepartamentos = false;
    if (hotelTrabajo != 0) {
      // Diferencias en departamentos, si se ha seleccionado hotel.
      cambiosDepartamentos = idsDepartamentosPoner.length > 0 || idsDepartamentosQuitar.length > 0;
    }

    // Diferencias en PDF
    const cambiosPDF = !!productoEdit.nuevoPDF;

    setHayCambios(cambiosCampos || cambiosDepartamentos || cambiosPDF);
  }, [productoEdit, idsDepartamentosPoner, idsDepartamentosQuitar, productoSeleccionado, hotelTrabajo]);

  return (
    <div className='container'>
      <div className='content'>
        <div className='article'>
          <div>
            <div className='header'>
              <div className='containerAcciones'>
                <ButtonGroup className="botonera" variant="contained" aria-label="outlined button group">
                  <HtmlTooltip
                    placement="bottom" enterDelay={500} leaveDelay={200} TransitionComponent={Zoom}
                    title={
                      <React.Fragment>
                        <Typography color="inherit">{"Crear Producto"}</Typography>
                      </React.Fragment>
                    }
                  >
                    <Button
                      className="boton-grande nuevoParte"
                      onClick={mostrarCrear}
                    >
                      <AddCircleOutlineIcon className='icon-button-big' />
                    </Button>
                  </HtmlTooltip>

                  <HtmlTooltip
                    placement="bottom" enterDelay={500} leaveDelay={200} TransitionComponent={Zoom}
                    title={
                      <React.Fragment>
                        <Typography color="inherit">{"Filtrar"}</Typography>
                      </React.Fragment>
                    }
                  >
                    <Button
                      className={activoFiltro === true ? "boton filtro pintado" : "boton filtro"}
                      onClick={mostrarFiltros}
                    >
                      <FilterAltIcon className='icon-button' />
                    </Button>
                  </HtmlTooltip>
                  <HtmlTooltip
                    placement="bottom" enterDelay={500} leaveDelay={200} TransitionComponent={Zoom}
                    title={
                      <React.Fragment>
                        <Typography color="inherit">{"Actualizar"}</Typography>
                      </React.Fragment>
                    }
                  >
                    <Button
                      className="boton"
                      onClick={actualizarProductos}
                    >
                      <RotateLeftIcon className='icon-button' />
                    </Button>
                  </HtmlTooltip>
                </ButtonGroup>
              </div>
            </div>
            <div className='grid-container'>
              <DataGrid
                className='grid'
                rowHeight={52}//63
                getRowClassName={(params) =>
                  params.indexRelativeToCurrentPage % 2 === 0 ? ' blanco' : ' fondogris blanco'
                }
                getRowId={(listaTodosProductos) => listaTodosProductos.id}
                onRowClick={clickInfoProducto}
                rows={listaTodosProductos}
                columns={columnas}
                maxColumns={6}
                pageSize={12}
                rowsPerPageOptions={[12]}
                initialState={{
                  sorting: {
                    sortModel: [{ field: 'nombre', sort: 'asc' }],
                  },
                }}
                localeText={{
                  noRowsLabel: "No se ha encontrado datos.",
                  noResultsOverlayLabel: "No se ha encontrado ningún resultado",
                }}
              />
            </div>
          </div>
        </div>

        <div className='aside' >
          {/* Lado derecho */}
          <div className='header'>
            <div className='containerAcciones'>

            </div>
          </div>
          <div className='grid-container'>
            {productoEdit ? (
              <>
                <div className='totalBloqueProducto'>
                  <div>
                    <div className='tituloBloqueProducto'><h3>Editar</h3></div>
                    <div className='bloqueProducto'>
                      <TextField
                        fullWidth
                        label="Nombre"
                        name="nombre"
                        value={productoEdit.nombre || ""}
                        onChange={handleEditChange}
                        margin="dense"
                      />
                      <TextField
                        fullWidth
                        label="Proveedor"
                        name="proveedor"
                        value={productoEdit.proveedor || ""}
                        onChange={handleEditChange}
                        margin="dense"
                      />
                      <TextField
                        fullWidth
                        label="Marca"
                        name="marca"
                        value={productoEdit.marca || ""}
                        onChange={handleEditChange}
                        margin="dense"
                      />
                      <div className="divEcoPdf">
                        <div className="divPdfEditar divInputProducto">
                          <label htmlFor="upload-pdf-edit" className="nuevoParteBotonAdjuntar">
                            <input
                              className="ocultar"
                              accept=".pdf"
                              id="upload-pdf-edit"
                              type="file"
                              onChange={(e) => {
                                const file = e.target.files[0];
                                if (file) {
                                  setProductoEdit((prev) => ({
                                    ...prev,
                                    nuevoPDF: file, // lo guardamos para enviar al update
                                  }));
                                  setHayCambios(true);
                                }
                              }}
                            />
                            <Button component="span" className="colorGrupo" variant="contained">
                              Cambiar archivo
                            </Button>
                          </label>

                          {/* Mostrar PDF actual o nuevo */}
                          <div className="divPdf">
                            {productoEdit.nuevoPDF ? (
                              <Button
                                className="nuevoParteNombrePdf botonProductoPdf"
                                variant="text"
                                onClick={() => {
                                  const url = URL.createObjectURL(productoEdit.nuevoPDF);
                                  window.open(url, "_blank"); // abre el pdf en una nueva pestaña
                                }}
                              >
                                {productoEdit.nuevoPDF.name}
                              </Button>
                            ) : (
                              <Button
                                className="nuevoParteNombrePdf botonProductoPdf"
                                variant="text"
                                onClick={() => ventanaImagen(productoEdit.rutaPDF)}
                              >
                                {String(productoEdit.id).padStart(6, "0")}.pdf
                              </Button>
                            )
                            }
                          </div>
                        </div>
                        <div className='divAplazado'>
                          <FormControlLabel
                            control={<Checkbox checked={!!productoEdit.eco} onChange={handleEditChange} className='checkBoxColor' name="eco" />}
                            label="Ecofriendly"
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div>
                    <div className='tituloBloqueProducto'><h3>Permisos</h3></div>
                    <div className='bloqueProducto'>
                      {/* // Select de hotel. */}
                      <TextField
                        className='hotelProducto'
                        variant="outlined"
                        margin="normal"
                        label="Hotel"
                        name="id_hotel"
                        size="small"
                        value={hotelTrabajo ? hotelTrabajo : ""}
                        onChange={cambiaHotelTrabajo}
                        select
                        SelectProps={{
                          MenuProps: {
                            PaperProps: {
                              sx: { maxHeight: { sm: 36 * 8 + 8 } }
                            }
                          }
                        }}
                      >
                        <MenuItem value={0}></MenuItem>
                        {hotelesLista.map((hotel) => (
                          <MenuItem key={hotel.value} value={hotel.value} >
                            {hotel.label}
                          </MenuItem>
                        ))}
                      </TextField>


                      {/* Lista de Departamentos */}
                      <Grid container spacing={2}>
                        {departamentosLista.map((dep) => {
                          const quitado = idsDepartamentosQuitar.includes(dep.id);
                          const puesto = idsDepartamentosPoner.includes(dep.id);
                          const asignado = departamentos.includes(dep.id); // Departamentos actualmente asignados al producto

                          return (
                            <Grid item xs={12} sm={6} md={3} key={dep.id}>
                              <Button
                                fullWidth
                                onClick={() => toggleDepartamento(dep.id)}
                                sx={{
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  color: 'black'
                                }}
                                className={`hotel ${puesto ? 'puesto textoBlanco' : 'no-permiso'} ${quitado ? 'quitado textoBlanco' : ''} ${asignado ? 'permiso textoBlanco' : ''}`}
                              >
                                {dep.nombre}
                              </Button>
                            </Grid>
                          );
                        })}
                      </Grid>
                    </div>
                  </div>

                  <div className='bloqueFinProducto'>
                    <Button
                      variant="outlined"
                      className={hayCambios ? 'colorGrupo borrarBoton' : 'colorDeshabilitado'}
                      disabled={!hayCambios}
                      onClick={cancelarEdicion}
                    >
                      Cancelar
                    </Button>
                    <Button
                      variant="contained"
                      className={hayCambios ? 'colorGrupo' : 'colorDeshabilitado'}
                      disabled={!hayCambios}
                      onClick={guardarEdicion}
                    >
                      Guardar
                    </Button>
                  </div>
                </div>
              </>
            ) : (
              <Typography variant="body2" sx={{ p: 2 }}>
                Selecciona un producto de la lista para editarlo.
              </Typography>
            )}
          </div>
        </div>
      </div>

      <CargaSpinner contadorSpinner={contadorSpinner} />
      <MostrarError mensajeEr={mensajeError} tipoError={tipoError} contadorError={contadorError} estadoAlert={estadoAlert} />

      <Dialog fullScreen={fullScreen}
        open={estadoCrear}
        onClose={comprobarESCCrear}
        aria-labelledby="responsive-dialog-title" id="dialogCrearProducto">
        <DialogTitle>Crear Producto</DialogTitle>
        <DialogContent>
          <div className='editarHab minimoFilaDialog'>

            <TextField
              label="Nombre"
              name="nombre"
              className='observaciones'
              variant="outlined"
              margin="normal"
              size="small"
              value={producto ? (producto.nombre ? producto.nombre : '') : ''}
              onChange={(e) => setProducto(prevState => ({ ...prevState, nombre: e.target.value }))}
              // inputProps={{ className: 'bold' }}
              // InputLabelProps={{ className: 'bold', shrink: true }}

              onKeyPress={(ev) => { comprobarEnterProd(ev) }}
              onBlur={(ev) => { comprobarProducto(ev) }}
              InputProps={
                {
                  className: 'bold', shrink: true,
                  endAdornment:
                    <IconButton
                      className="boton buscador"
                      onClick={comprobarProducto}
                    >
                      <SearchIcon className='icon-button ' />
                    </IconButton>
                }}
              autoComplete="off"
            />
          </div>
          <div className='editarHab minimoFilaDialog'>
            <div className='divCrearProducto'>
              <div className='divInputProducto'>
                <TextField
                  label="Proveedor"
                  name="proveedor"
                  variant="outlined"
                  margin="normal"
                  size="small"
                  value={producto ? (producto.proveedor ? producto.proveedor : '') : ''}
                  onChange={(e) => setProducto(prevState => ({ ...prevState, proveedor: e.target.value }))}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  autoComplete="off"
                />
                <TextField
                  label="Marca"
                  name="marca"
                  variant="outlined"
                  margin="normal"
                  size="small"
                  value={producto ? (producto.marca ? producto.marca : '') : ''}
                  onChange={(e) => setProducto(prevState => ({ ...prevState, marca: e.target.value }))}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  autoComplete="off"
                />
                <div className='divAplazado'>
                  <FormControlLabel
                    control={<Checkbox checked={!!producto.eco} onChange={(e) => setProducto(prevState => ({ ...prevState, eco: e.target.checked }))}
                    className='checkBoxColor' name="eco" />}
                    label="Ecofriendly"
                  />
                </div>
                <label htmlFor="upload-files" className='nuevoParteBotonAdjuntar'>
                  <input
                    className='ocultar'
                    accept=".pdf"
                    id="upload-files"
                    type="file"
                    onChange={selecImage}
                  // multiple
                  />
                  <Button component='span' className='colorGrupo' variant="contained">Adjuntar archivo</Button>
                </label>
              </div>
              <div className='divPdf'>
                {listaPDFNuevoParte.length > 0 ?
                  <div>
                    {listaPDFNuevoParte.map((pdf, j) => {
                      return (
                        <div className='' key={pdf.id}>
                          <Button className='nuevoParteNombrePdf' variant="text" onClick={() => ventanaImagen(pdf.ruta)} >{pdf.nombre ? pdf.nombre : ''}</Button>
                          <IconButton className='iconX' onClick={() => borrarPDFNuevoParte(pdf.id)}>x</IconButton>
                        </div>
                      );
                    })
                    }
                  </div>
                  : ''
                }
              </div>
            </div>
          </div>

          {/* <div className='color-container '> */}
          <div className='bloqueHistoricoProductos'>
            {/* Listado de productos encontrados */}
            {listaProducto.length > 0 ? (
              <List className='productoLista'>
                {listaProducto.map((prod) => (
                  <div key={prod.id}>
                    <ListItem className='liProductoLista'>
                      <ListItemText
                        primary={`${prod.completo}`}
                        secondary={`ID: ${prod.id} - Marca: ${prod.marca || "N/A"}  - Proveedor: ${prod.proveedor || "N/A"} - Producto: ${prod.nombre || "N/A"} - Activo: ${prod.activo === "1" ? "Sí" : "No"}`}
                      />
                    </ListItem>
                    <Divider />
                  </div>
                ))}
              </List>
            ) : (
              ""
            )}
          </div>
        </DialogContent>
        <DialogActions>
          <ButtonGroup className="botonera" variant="contained" aria-label="outlined button group">
            <Button className="colorGrupo borrarBoton" onClick={cancelCrear}>Cancelar</Button>
            <Button className="colorGrupo" onClick={crearProducto}>Crear</Button>
          </ButtonGroup>
        </DialogActions>
      </Dialog>

      <Dialog fullScreen={fullScreen}
        open={estadoFiltro}
        onClose={comprobarESCFiltrar}
        aria-labelledby="responsive-dialog-title" id="dialogFiltroProductos">
        <DialogTitle>Filtrar Productos</DialogTitle>
        <DialogContent>
          <div className='bloque-inputs-filtros'>
            <TextField
              variant="outlined"
              margin="normal"
              type="text"
              label="ID"
              onKeyPress={comprobarEnter}
              name="id"
              size="small"
              className='inputIdFiltro'
              value={tempFiltros.id || ''}
              onChange={actualizarFiltros}
              autoComplete="off"
            />
            <TextField
              variant="outlined"
              margin="normal"
              label="Nombre"
              onKeyPress={comprobarEnter}
              name="nombre"
              size="small"
              className='inputNombreFiltro'
              value={tempFiltros.nombre || ''}
              onChange={actualizarFiltros}
              autoComplete="off"
            />
          </div>
          <div className='bloque-inputs-filtros'>
            <TextField
              variant="outlined"
              margin="normal"
              label="Proveedor"
              onKeyPress={comprobarEnter}
              name="proveedor"
              size="small"
              className='inputProductoFiltro'
              value={tempFiltros.proveedor || ''}
              onChange={actualizarFiltros}
              autoComplete="off"
            />
            <TextField
              variant="outlined"
              margin="normal"
              label="Marca"
              onKeyPress={comprobarEnter}
              name="marca"
              size="small"
              className='inputProductoFiltro'
              value={tempFiltros.marca || ''}
              onChange={actualizarFiltros}
              autoComplete="off"
            />
          </div>
          <div className='bloque-inputs-filtros justificarCentro centrar'>
            <FormControl component="fieldset" style={{ marginTop: "16px" }}>
              <FormLabel component="legend">Estado</FormLabel>
              <RadioGroup
                row
                name="activo"
                value={tempFiltros.activo}
                onChange={actualizarFiltros}
              >
                <FormControlLabel value="" control={<Radio />} label="Todos" />
                <FormControlLabel value="1" control={<Radio />} label="Activos" />
                <FormControlLabel value="0" control={<Radio />} label="Inactivos" />
              </RadioGroup>
            </FormControl>

            <div className='divAplazado'>
              <FormControlLabel
                control={<Checkbox checked={!!tempFiltros.eco} onChange={actualizarFiltros}
                className='checkBoxColor' name="eco" />}
                label="Ecofriendly"
              />
            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <Button className="colorGrupo botonBorrarFiltros" onClick={borrarFiltros}>Limpiar Filtros</Button>
          <ButtonGroup className="botonera" variant="contained" aria-label="outlined button group">
            <Button className="colorGrupo borrarBoton" onClick={cancelFiltrar}>Cancelar</Button>
            <Button className="colorGrupo" onClick={filtrarProductos}>Filtrar</Button>
          </ButtonGroup>
        </DialogActions>
      </Dialog>

    </div>

  );
}

export default Productos;